// Shared application constants

// Total ms the spinner stays mounted after data is ready; must match .is-leaving's transition-delay + duration.
export const SPINNER_FADE_HOLD_DURATION = 150;
export const SPINNER_FADEOUT_DURATION = SPINNER_FADE_HOLD_DURATION + 300;
